module.exports = __webpack_public_path__ + "static/media/assessment-yet-to-begin.6e3c7dfd.svg";